exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".funcLink.designMode{color:#06c}.funcLink.designMode.warning{color:#da8028}.funcLink.designMode.current{border-top:1px dashed purple}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-665c7dee","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/ctrl/FuncMap.vue
// module id = 3244
// module chunks = 1